export default __webpack_public_path__ + "static/media/HardwoodImg.97e6a576.png";